// extracted by mini-css-extract-plugin
export var body = "contactColumns-module--body--9d395";
export var box = "contactColumns-module--box--b8472";
export var button = "contactColumns-module--button--f88bc";
export var column = "contactColumns-module--column--5d776";
export var columnTitle = "contactColumns-module--column-title--e3706";
export var contactColumns = "contactColumns-module--contact-columns--be6dd";
export var grid = "contactColumns-module--grid--5ffc0";
export var headline = "contactColumns-module--headline--f7098";
export var inner = "contactColumns-module--inner--84f12";
export var lineItem = "contactColumns-module--line-item--df591";
export var lineItemButton = "contactColumns-module--line-item-button--b4b19";
export var lineItemCentered = "contactColumns-module--line-item-centered--bc2a5";
export var lineItemDescription = "contactColumns-module--line-item-description--33b35";
export var lineItemText = "contactColumns-module--line-item-text--acb2d";
export var lineItemTitle = "contactColumns-module--line-item-title--36cc1";